(() => {
  const update = root => {
    const select = root.querySelector('[data-hu-shipping-destination]');
    if (!select) return;
    const country = select.value;
    let matched = false;
    root.querySelectorAll('[data-hu-shipping-countries]').forEach(row => {
      const show = Boolean(country) && row.dataset.huShippingCountries.split(' ').includes(country);
      row.hidden = !show;
      matched ||= show;
    });
    root.querySelector('[data-hu-shipping-table]').hidden = !matched;
    root.querySelector('[data-hu-shipping-prompt]').hidden = matched;
    root.querySelector('[data-hu-shipping-us]').hidden = country !== 'US';
  };
  const init = parent => parent.querySelectorAll('[data-hu-confirmed-shipping]').forEach(update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('change', event => {
    if (event.target.matches('[data-hu-shipping-destination]')) update(event.target.closest('[data-hu-confirmed-shipping]'));
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
